import { scrollToSection } from "../hooks/useLenis";

const LOGO =
    "https://customer-assets-jt897jd0.emergentagent.net/job_b27ff44d-5001-4718-90bb-7f512a6d425a/artifacts/bkw34fsr_4B0C15C0-DB1B-4AE6-B2B8-3386D3826D16.png";

const NAV = [
    { label: "Services", id: "services" },
    { label: "Who We Build For", id: "audience" },
    { label: "Work", id: "work" },
    { label: "Process", id: "process" },
    { label: "About", id: "about" },
    { label: "Contact", id: "contact" },
];

export const Footer = () => (
    <footer className="relative overflow-hidden border-t border-[#0A0F1D]/10" data-testid="footer">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="grid gap-12 md:grid-cols-2">
                <div>
                    <div className="flex items-center gap-4">
                        <img src={LOGO} alt="Footman Digital Solutions logo" className="h-12 w-12 rounded-xl" />
                        <div>
                            <p className="font-display text-lg tracking-[0.14em] text-[#0A0F1D]">FOOTMAN</p>
                            <p className="font-mono text-[9px] uppercase tracking-[0.34em] text-sky-400">Digital Solutions</p>
                        </div>
                    </div>
                    <p className="mt-5 font-display text-xl text-slate-600">&ldquo;Your Vision. Online.&rdquo;</p>
                    <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                        Ideas <span className="text-sky-500">|</span> Websites <span className="text-sky-500">|</span> Brands <span className="text-sky-500">|</span> Impact
                    </p>
                </div>

                <nav aria-label="Footer navigation" className="md:justify-self-end">
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Explore</p>
                    <ul className="mt-5 space-y-3">
                        {NAV.map((l) => (
                            <li key={l.id}>
                                <button
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={() => scrollToSection(l.id)}
                                    className="text-sm text-slate-600 transition-colors duration-300 hover:text-[#0066FF]"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className="mt-14 select-none overflow-hidden" aria-hidden="true">
                <p className="outline-text whitespace-nowrap text-center font-display text-[13.5vw] leading-none tracking-tight">
                    FOOTMAN
                </p>
            </div>

            <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[#0A0F1D]/10 pt-8 sm:flex-row">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                    © 2026 Footman Digital Solutions
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                    Designed &amp; built in-house. Obviously.
                </p>
            </div>
        </div>
    </footer>
);
